<template>
  <div v-if="hasRunning" class="install-mask">
    <div class="install-mask-content">
      <a-spin size="large" />
      <div class="install-mask-text">安装中，请稍候...</div>
    </div>
  </div>
  <a-layout>
    <a-layout-header :style="{position: 'fixed', zIndex: 13, width: '100%'}">
      <div class="main-header xn-flex-center">
        <div class="main-logo xn-flex">
          <a href="https://www.xinnet.com" target="_blank">
            <img class="logo" src="@/assets/images/logo.png" width="74" height="20">
          </a>
          <div class="hostInfo">
              <div class="tip">当前虚拟主机</div>
              
              <a-dropdown v-if="LoginSource == 'HOST_TOKEN'" class="hostInfoDropdown" v-model:visible="showList" style="width: 478px;" trigger="click" @click="getListHandel">
                <a class="ant-dropdown-link" @click.prevent>
                  <div class="host">{{ currentHost }}<img style="transform: translateY(-2px);" src="@/assets/images/down _arrow.png"></div>
                </a>
                <template #overlay>
                  <a-menu :virtual="false" class="header-list" style="width: 478px;padding: 16px;max-height: 354px;overflow: hidden;box-shadow: 0px 9px 28px 8px rgba(0,0,0,0.05), 0px 6px 16px 0px rgba(0,0,0,0.08), 0px 3px 6px -4px rgba(0,0,0,0.12);border-radius: 8px;margin-top: 2px;padding-left: 0;padding-right: 0;" ref="scrollContainer"
                        >
                    <div style="width: 478px;margin-left: 16px;margin-bottom: 0px;">
                      <a-input-group compact>
                        <a-select style="width: 120px;" v-model:value="searchType">
                          <a-select-option value="hostName">站点名/备注</a-select-option>
                          <a-select-option value="domain">域名</a-select-option>
                        </a-select>
                        <a-input
                          v-model:value="searchValue"
                          :placeholder="searchType === 'hostName' ?  '请输入站点名或备注(模糊搜索)' : '请输入域名(模糊搜索)'"
                          style="width: 323px"
                          @change="getListHandel"
                        >
                          <template #suffix>
                            <SearchOutlined
                              style="color: rgba(0, 0, 0, 0.25)"
                            />
                          </template>
                        </a-input>
                      </a-input-group>
                    </div>
                    <div style="height: 300px;overflow-y: auto;overflow-x: hidden;" @scroll="handleScroll">
                      <a-menu-item v-for="item in hostList" :key="item.hostCode" @click="changeHostHandel(item)" :class="item.hostName === currentHost ? ['dropdownItems  dropdownItemsActive'] :  ['dropdownItems'] " style="padding:0;border-radius: 0;">
                        <div style="padding: 14px 0px;margin: 0px 16px;border-bottom: solid 1px #E9E9E9;">
                          <div class="dropdownItem">
                          <!-- <img src="@/assets/images/header_list_icon.png" /> -->
                            <span class="imgs"></span>
                            <span class="text" style="margin-left: 8px;">{{item.hostName}}</span>
                            <span class="tip" style="margin-left: 6px;">({{ item?.specInfo?.osType }})</span>
                          </div>
                          <div v-if="item.domains && item.domains.length > 0" class="text1">
                            <!-- www.xinner.com | www.xinner.com | www.xinner.com  -->
                            <span class="textDomains" v-for="(itemDomain, ind) in item.domains">
                              {{ itemDomain}}
                              <span v-if="ind !== item.domains.length - 1">|</span>
                            </span>
                          </div>
                          <div v-else class="text1" >暂未绑定域名</div>
                          <div class="tip1" v-if="item.remark">
                            {{ item.remark }}
                          </div>
                        </div>
                      </a-menu-item>
                    </div>
                  </a-menu>
                </template>
              </a-dropdown>
              <div v-else>
                <div class="host">{{ currentHost }}</div>
              </div>
          </div>
          <!-- <span class="title s4-ml">虚拟主机控制台</span> -->
        </div>
        <div class="main-navbar">
          <a class="link" href="https://support.xinnet.com/#/submit" target="_blank">提交工单</a>
          <a class="link" href="https://tas.xinnet.com/#/service/icpManager" target="_blank" v-if="$auth(['USER', 'ADMINISTRATOR'])">专家服务</a>
          <a class="link" href="https://www.xinnet.com/service/service.html" target="_blank">
            帮助文档
          </a>
          <a-dropdown
            v-model:open="showTasks"
            class="s10-mr" arrow
            placement="bottom" trigger="click"
            @openChange="triggerTasks"
          >
            <span class="xn-pointer" id="taskMsg">
              <a-badge :count="count" size="small">
                <span>任务消息</span>
              </a-badge>
              <CaretDownOutlined class="s2-ml" />
            </span>
            <template #overlay>
              <Tasks :tasks="tasks" :getTasks="getTasks" />
            </template>
          </a-dropdown>
          <a class="xn-pointer s6-mr" style="color: #000;"  @click="handleLogout">退出登录</a>
          <!-- <a-dropdown
            class="s6-mr" arrow
            placement="bottom"
          >
            <span class="xn-pointer drop-button">
              <xn-icon icon="user" class="icon" />
              <span class="s2-ml">
                {{ $store.state.hostInfo?.hostService?.hostName || '' }}
              </span>
            </span>
            <template #overlay>
              <a-menu>
                <a-menu-item class="xn-text-center">
                  <a class="xn-pointer" @click="handleLogout">退出</a>
                </a-menu-item>
              </a-menu>
            </template>
          </a-dropdown> -->
        </div>
      </div>
    </a-layout-header>

    <a-layout style="background-color: #f5f7fb;">
      <transition>
        <a-layout-sider theme="light" width="208px" :style="{ overflow: 'auto', height: '100vh-60px', marginTop: '56px', position: 'fixed', left: 0, top: 0, bottom: 0 }" v-model:collapsed="collapsed">
          <div class="main-menu">
            <div style="height: 4px;"></div>
            <div :class="['menu', 'xn-pointer', { active: isHome }]" @click="goHome">
              <xn-icon icon="home" class="xn-icon" />
              <span class="s2-ml">首页</span>
            </div>
            <div class="bhr"></div>
            <div style="height:4px"></div>
          </div>
          <a-menu
            ref="menus"
            mode="inline"
            class="cp-left-menu"
            v-model:openKeys="openKeys"
            v-model:selectedKeys="selectedKeys"
            @click="menuClick"
          >
            <menus :list="menuList" />
          </a-menu>
        </a-layout-sider>
      </transition>

      <a-layout class="s5-ml" :style="{ marginLeft: '208px' }">
        <a-layout-content>
          <!-- <div class="main-container"> -->
            <div class="main-content">
                <router-view />
            </div>
          <!-- </div> -->
        </a-layout-content>
      </a-layout>
    </a-layout>
  </a-layout>
  <xn-modal width="600px" uid="configAuto" title="温馨提示" :closable='false'>
    <div>
      镜像安装完成,是否需要自动配置主机环境？
    </div>
    <div class="xn-footer">
      <a-button @click="toCancel">取消配置</a-button>
      <a-button type="primary" @click="tohandleConfirm">开始配置</a-button>
    </div>
  </xn-modal>
  <xn-modal width="600px" uid="isSubmit" title="温馨提示" :closable='false'>
    <xn-alert type="warning">
        <p>
          此操作将会清空当前主机所有配置使用镜像配置覆盖，是否继续？
        </p>
    </xn-alert>     
    <div class="xn-footer">
      <a-button @click="toCancel">取消配置</a-button>
      <a-button type="primary" @click="toConfirms">开始配置</a-button>
    </div>
  </xn-modal>
  <xn-modal width="450px" uid="configuration" title="主机环境配置中" :closable='false'>
     <xn-alert type="warning">
        <p>1.配置中,请勿离开,离开可能导致配置失败</p>
        <p>2.配置失败项请前往主机环境配置手动配置</p>
      </xn-alert>
    <div class="progress-container">
      <div class="progress-item" v-for="(item, index) in progressList" :key="index">
        <!-- <a-icon :type="item.icon" class="progress-icon" /> -->
        <div class="progress-text">
          <span class="progress-title">{{ item.title }}</span>
          <CheckCircleTwoTone v-if="item.status === 'success'" twoToneColor="#52c41a" />
          <CloseCircleTwoTone v-if="item.status === 'exception'" twoToneColor="#FF4D4F" />   
          <!-- <a-progress :percent="item.percent" :status="item.status" class="progress-bar" /> -->
          <!-- <span class="progress-status" :></span> -->
        </div>
      </div>
      <a-button type="primary" class="next-button" :disabled="settingShow" style="width: 100%;" @click="toCancel">
        配置完成
      </a-button>
    </div>
      <!-- <div class="xn-footer">
        <a-button @click="toCancel">取消</a-button>
        <a-button type="primary" @click="toConfirm">开始配置</a-button>
      </div> -->
  </xn-modal>
  <contextHolder />

  <a-drawer title="任务详情" :open="open" @close="onClose">
    <detail :row="curRow" />
  </a-drawer>
</template>

<script setup lang="ts">
import { provide, computed, ref, h, resolveComponent, watch, onMounted } from 'vue'
import { useStore } from 'vuex'
import { useRouter, useRoute } from "vue-router"
import { CaretDownOutlined, SearchOutlined, CheckCircleTwoTone, CloseCircleTwoTone} from '@ant-design/icons-vue'
import { notification } from 'ant-design-vue'
import Tasks from './tasks.vue'
import Menus from './menus.vue'
import { logout, getAllHostList, getLoginSource, changeHost, updateTaskStatus } from '@/api/main'
import { queryTaskList, updateTask, getCloneInfo } from '@/api/task'
import Detail from '@/views/taskCenter/detail.vue'
import { queryTaskPage } from '@/api/task'
import { setDefaultHomePage,setRedirectConfig,setErrorPage,setDotnetScriptError,addMimeConfig,setPhpLang,setPhpChangeVersion,updatePhpParam,setPhpErrorLog,setPhpOb,setPhpUpload,setPhpMaxUploadSize,setPhpDisableFuncs,setDotnetTrustedLevel,setDotnetChangeVersion,clearConfig } from '@/api/home'
import { rewriteSet } from '@/api/pseudoStatic'

const store = useStore()
const router = useRouter()
const route = useRoute()
const menus = ref()
const collapsed = ref(false)
const openKeys: any = ref([])
const selectedKeys: any = ref([])
const isHome = ref(false)
const count = ref(0)
const runningTask = ref('')
const notifyClose = ref()
const notifyCode = ref('')
const showTasks = computed(() => {
  return store.state.tempTask.showTasks
})

const showList = ref(false)
const searchType = ref<string>('hostName');
const searchValue = ref<string>('');
const settingShow = ref(true)


const scrollContainer = ref<HTMLElement | null>(null)
let isLocked = false // 防止重复触发

const handleScroll = () => {
  checkScroll()
}

// 添加加载状态和防抖
const isLoading = ref(false);
const hasMore = ref(true);
let lastScrollTime = 0;
const pageCount = ref(0);

const checkScroll = () => {
  // 获取真实的滚动容器DOM
  const scrollContainerEl = scrollContainer.value?.$el;
  if (!scrollContainerEl) return;
  const { scrollTop, scrollHeight, clientHeight } = scrollContainerEl;
  const isNearBottom = scrollHeight - (scrollTop + clientHeight) <= 100;

  const now = Date.now();
  // console.log(pageCount.value,'pageCount.value',isLoading.value,'isLoading.value',now - lastScrollTime,'now - lastScrollTime')
  // console.log(isNearBottom && hasMore.value && !isLoading.value && (now - lastScrollTime > 300))
  
  if (isNearBottom && hasMore.value && !isLoading.value && (now - lastScrollTime > 300)) {
    isLoading.value = true;
    lastScrollTime = now;
    pagesMax.value == pageIndex.value ?  pageIndex.value = pagesMax.value : pageIndex.value += 1
    // console.log(pagesMax.value,'pagesMax')
    // console.log('加载更多',count)
    if(pageCount.value < 1){
      getAllHostList(pageIndex.value,pageSize.value,{[searchType.value]:searchValue.value}).then((res:any) => {
        if(res.code === '200'){
          hostList.value = [...hostList.value,...res.res?.hostList?.records]
          isLoading.value = false;
        }
      })
    }
    if(pageIndex.value == pagesMax.value){
      // console.log('没有更多数据了',count)
      pageCount.value = 1
    }
    
  }
};


const changeHostHandel = (item) => {
  if(LoginSource.value == 'HOST_TOKEN'){
    let params = new FormData()
    params.append('hostCode', item.hostCode)
    changeHost(params).then(res => {
      if(res.code == '200'){
        window.location.reload()
      }
    })
  }
  
}

const menuList = computed(() => {
  return store.state.menuList
})

const triggerTasks = (val) => {
  store.commit('tempTask/triggerTask', val)
}

const goHome = () => {
  router.push('/')
  selectedKeys.value = []
}

const handleCollapse = () => {
  collapsed.value = !collapsed.value
}

const flattenData = (list: any, _result?) => {
  const result: any = _result || []
  list.forEach(({ children, ...rest }) => {
    result.push(rest)
    if (children?.length) {
      flattenData(children, result)
    }
  })
  return result
}

const handleLogout = async () => {
  try {
    const res: any = await logout()
    window.location.reload()
    Xinnet.message.success(res.msg)
  } catch(e) {
    console.error('登出失败！')
  }
}

const hostList:any = ref([])
const pageIndex = ref(1)
const pageSize = ref(10)
const pagesMax = ref(0)
const getListHandel = () => {
  hostList.value = []
  pageCount.value = 0
  pageIndex.value = 1
  isLoading.value = false;
  getAllHostList(pageIndex.value,pageSize.value,{[searchType.value]:searchValue.value}).then((res:any) => {
    if(res.code === '200'){
      hostList.value = res.res?.hostList?.records || []
      pagesMax.value = res.res?.hostList?.pages || 0
    }
  })
}

watch(route, (curRoute) => {
  try {
    if (curRoute.matched?.length && store.state.menuList?.length) {
      const items = curRoute.matched.slice(0, -1)
      const list = flattenData(store.state.menuList)
      // openKeys.value = items.reduce((r: any, o) => {
      //   const exist: any = list.find(c => c.path === o.path)
      //   if (exist) {
      //     r.push(exist.key)
      //   }
      //   return r
      // }, [])
      // 默认全部展开菜单
      openKeys.value = list.map(o => o.key)
      // 已选中菜单
      const selectedItem = list.find((o) => {
        return o.path === curRoute.matched.at(-1)?.path
      })
      if (selectedItem) {
        selectedKeys.value = [selectedItem.key]
      }

      // 选中首页
      if (!openKeys.value?.length && !selectedKeys.value?.length) {
        isHome.value = true
      } else {
        isHome.value = curRoute.path === '/'
      }
    }
    if (curRoute.path === '/') {
      selectedKeys.value = []
    }
  } catch(e) {
    console.error('解析openKeys失败！')
  }
}, { immediate: true })

const menuClick = (e) => {
  const list = flattenData(store.state.menuList)
  const item = list.find(o => o.key === e.key)
  item && router.push(item.path)
}

// 获取网站搬家数据
const getSite = async (taskCode, t) => {
  const res: any = await getCloneInfo(taskCode)
  t.file = res?.res || {}
  if (t.file?.copiedBytes) {
    t.file.copiedBytes = Xinnet.util.fileDiskSize(t.file.copiedBytes, 2)
  }
}


// 查看任务详情
const open = ref<boolean>(false)
const curRow = ref<any>({})

const onClose = () => open.value = false

const previewDetail = (row) => {
  curRow.value = row
  open.value = true
}


const ticktock: any = ref(0)
const day = 1000 * 60 *60 * 24
const _tasks = ref<any[]>([])
const tasks = ref<any[]>([])
const [api, contextHolder] = notification.useNotification()

const getTasks = (hostCode, init = false) => {
  queryTaskList({ hostCode }).then((res: any) => {
    _tasks.value = tasks.value = res.res?.map((o) => {
      // 解决任务盒子-网站搬家闪动BUG
      if (o.taskType === 'SITE_MOVE') {
        o.file = tasks.value.find((t) => o.id === t.id)?.file
      }
      return o
    }) || []
    // 有未完成的文件类任务，不创建临时任务（临时任务属于文件类任务，只能有一个运行中的）
    const runningFileTask = tasks.value.find((o) => {
      return o.taskType !== 'DB_BACKUP' && ['RUNNING', 'WAIT'].includes(o.taskStatus)
    })
    if (runningFileTask) {
      store.commit('tempTask/setLocked', true)
    } else {
      store.commit('tempTask/setLocked', false)
    }
    tasks.value = tasks.value.slice(0, 5)
    if (store.state.tempTask.taskList?.[0]?.fileList?.length) {
      addTempTask(store.state.tempTask.taskList)
    }
    let num = 0
    tasks.value?.forEach((t) => {
      if(t.taskStatus == 'RUNNING' || t.taskStatus == 'WAIT') {
        num += 1
        if(num == 1 && runningTask.value != t.id) {
          runningTask.value = t.id
          runningNotify(t)
        }
      }
      // 一天内已完成（成功|失败）的任务，非临时任务轮训通知
      if (!['UPLOAD_FILE', 'COMPRESS', 'DECOMPRESS'].includes(t.taskType)) {
        const inHour24 = (+new Date() - +new Date(t.createTime)) <= day
        if (
          ['RUNNING_SUCCESS', 'RUNNING_FAIL'].includes(t.taskStatus)
          && t.notifyStatus === 0 && inHour24
        ) {
          notify(t)
        }
        // 已完成未读任务修改状态
        if (t.notifyStatus === 0) {
          updateTask(t.id)
        }
        // 获取网站搬家数据
        if (t.taskType === 'SITE_MOVE' && t.preTaskCode) {
          getSite(t.preTaskCode, t)
          if(t.taskStatus == 'WAIT' || t.taskStatus == 'RUNNING') {
            if(num == 1) {
              runningTask.value = t.id
              runningNotify(t)
            }
          }
        }
      }
    })
    count.value = num
  })

  if (init) {
    clearTimeout(ticktock.value)
    ticktock.value = setTimeout(() => {
      getTasks(hostCode, init)
    }, 5000)
  }
}

const taskInfos = ref('1223')
const taskCloseId = ref()
const runningNotify = (t) => {
  api.destroy(notifyCode.value)
  
  const type = Xinnet.settings.taskTypeOpts.find((o) => o.value === t.taskType)?.text
  const state = Xinnet.settings.taskStatusOpts.find((o) => o.value === t.taskStatus)?.text
  const description = `${type}任务${state}`
  taskInfos.value = getRunningDesc(t.taskType, t)
  
  if(taskCloseId.value != runningTask.value) {
    notifyClose.value = api.info({
      message: description,
      placement: 'bottomLeft',
      duration: 6000,
      key: t.id,
      onClose: () => {
        taskCloseId.value = t.id
      },
      description: () => {
        return taskInfos.value
      },
      icon: () => {
        const type = 'primary'
        return h(
          resolveComponent('xn-icon'),
          {
            icon: `alert_${type}`,
            class: 'icon',
            style: { height: '24px', width: '24px' }
          }
        )
      }
    })
    notifyCode.value = t.id
  }
}

const getRunningDesc = (type, task) => {
  if (type === 'UPLOAD_FILE') {
    return `已上传${task.uploaded}个文件${task.size ? `（${task.size}）` : ''}，${task.failed ? '失败'+ task.failed +'个，' : ''}剩余${task.uploading}个文件，正在上传第${task.whichFile}个文件进度${task.ratio}%`
  }
  if (type === 'SITE_MOVE') {
    let curFile = ''
    if (task.file?.processing) {
      curFile = extractLastSlash(task.file.processing)
    }
    return `已搬运${task.file?.copiedFiles || 0}个文件${task.file?.copiedBytes ? `（${task.file.copiedBytes}）` : ''}，正在传输${curFile}`
  }
  if (type === 'DECOMPRESS') {
    const filename = extractLastSlash(task.filename)
    return `正在解压 ${filename} ${task.processed}/${task.total}`
  }
  if (type === 'COMPRESS') {
    if (task.progress) {
      return `正在下载，进度${task.progress}%`
    }
    if (task.downloaded) {
      return `正在下载，已下载${task.downloaded}，下载速度${task.rate}`
    }
    return '正在下载'
  }
  if (type === 'APP_INSTALL') {
    try {
      return `正在安装 ${JSON.parse(task.taskParam)?.appName}`
    } catch(e) {
      return ''
    }
  }
  if (type === 'WEB_BACKUP') return '正在备份'
  if (type === 'DB_BACKUP') return '正在备份'
  if (type === 'WEB_BACKUP_RESTORE') return '正在恢复'
}


const extractLastSlash = (str) => {
  let res = ''
  if (str) {
    const lastIndex = str.lastIndexOf('/')
    res = str.substring(lastIndex + 1)
  }
  return res
}

// 通知
const notify = (t) => {
  if(t.id == runningTask.value) {
    api.destroy()
  }
  const type = Xinnet.settings.taskTypeOpts.find((o) => o.value === t.taskType)?.text
  const state = Xinnet.settings.taskStatusOpts.find((o) => o.value === t.taskStatus)?.text
  const description = `${type}任务${state}`
  const isFailed = t.taskStatus === 'RUNNING_FAIL'
  const message = isFailed ? '任务失败' : '任务完成'
  api.info({
    message: message,
    placement: 'bottomLeft',
    description: () => {
      if (isFailed) {
        return h(
          'div',
          [
            h(
              'span',
              {
                style: {
                  'display': 'inline-block',
                  'paddingRight': '20px',
                  'width': 'calc(100% - 60px)',
                }
              },
              description
            ),
            h(
              'span',
              { style: { 'textAlign': 'right', 'width': '60px' }},
              [
                h(
                  'span',
                  {
                    class: 'xn-link xn-pointer s3-mt',
                    onClick: () => previewDetail(t)
                  },
                  '任务详情'
                )
              ]
            )
          ]
        )
      }
      return description
    },
    icon: () => {
      const type = isFailed ? 'danger' : 'success'
      return h(
        resolveComponent('xn-icon'),
        {
          icon: `alert_${type}`,
          class: 'icon',
          style: { height: '24px', width: '24px' }
        }
      )
    }
  })
}

const currentHost = ref('')
const LoginSource = ref('')
onMounted(() => {
  clearTimeout(ticktock.value)
  // console.log(route,route.meta,route.path,'route')
  if(window.location.hash.indexOf('login') == -1){
    getAllHostList(pageIndex.value,pageSize.value,{}).then((res:any) => {
      if(res.code === '200'){
        currentHost.value = res.res?.currentHostName || ''
      }
    })
    getLoginSource().then((res:any) => {
      if(res.code === '200'){
        LoginSource.value = res.res
        // console.log(res.res,'getLoginSource')
        // store.commit('hostInfo/setHostService', res.res)
      }
    })
  }
  if(store.state.hostInfo?.specInfo?.language?.includes('NET')) {
    progressList.value.push({ icon: 'wordpress', title: '设置脚本错误信息', percent: 100, status: 'normal' })
    progressList.value.push({ icon: 'wordpress', title: '.NET设置', percent: 100, status: 'normal' })
  }
 
})

const hasRunning = ref(false)
const configAuto = ref(false)
let taskTimer: any = null
const currentConfigImageConfig:any = ref('')
const currentConfigTaskId:any = ref('')

const queryTaskPageHandel = (hostCode) => {
  queryTaskPage({ hostCode, current: 1, pageSize: 20 }, { taskType: "APP_INSTALL" }).then((res: any) => {
    hasRunning.value = Array.isArray(res.res.elements) && res.res.elements.some(item => item.taskStatus === 'RUNNING');
    // 查找第一个postStatus为CONFIGURATION的任务
    const configTask = Array.isArray(res.res.elements) && res.res.elements.find(item => item.postStatus === 'CONFIGURATION');
    configAuto.value = !!configTask;
    if(configAuto.value){
      currentConfigImageConfig.value = JSON.parse(configTask.taskInfo)?.imageConfig;
      currentConfigTaskId.value = configTask.id
      console.log(configTask,'currentConfigTaskInfo.value',currentConfigImageConfig.value)
      store.commit('modal/open', { uid: 'configAuto' })
    }
    if (hasRunning.value) {
      taskTimer = setTimeout(() => queryTaskPageHandel(hostCode), 5000)
    } else {
      if (taskTimer) {
        clearTimeout(taskTimer)
        taskTimer = null
      }
    }
  })
}

// 调用 updateTaskStatus 时传递 taskId
const toCancel = ()=> {
  localStorage.removeItem('hasReloaded');
  console.log(currentConfigTaskId.value)
  updateTaskStatus(currentConfigTaskId.value,{postStatus:'CONFIGURATION_STOP'}).then(res=>{
    store.commit('modal/close')
  })
}

// const toClearCancel = () => {
//   store.commit('modal/close')
// }

const tohandleConfirm = () => {
   store.commit('modal/close',{uid:'configAuto'})
  store.commit('modal/open',{uid:'isSubmit'})
}

const toConfirms = () => {
  clearConfig().then((res) => {
    if(res.code == '200') {
      toConfirm()
    }
  })
}

const toConfirm = async () => {
  store.commit('modal/close', {uid: 'isSubmit'})
  store.commit('modal/open', { uid: 'configuration' })

  // 1. 设置网站首页
  progressList.value[0].percent = 0
  progressList.value[0].status = 'normal'
  const homePromise = setDefaultHomePage({ docs: currentConfigImageConfig.value.indexPath })
    .then(() => {
      progressList.value[0].percent = 100
      progressList.value[0].status = 'success'
    })
    .catch(() => {
      progressList.value[0].percent = 100
      progressList.value[0].status = 'exception'
    })

  // 2. 设置伪静态
  progressList.value[1].percent = 0
  progressList.value[1].status = 'normal'
  let rewritePromise = Promise.resolve()
  if(currentConfigImageConfig.value.rewriteCode == '' || !currentConfigImageConfig.value.rewriteCode) {
    progressList.value[1].percent = 100
    progressList.value[1].status = 'success'
  } else {
    rewritePromise = rewriteSet(currentConfigImageConfig.value.rewriteCode)
    .then(() => {
      progressList.value[1].percent = 100
      progressList.value[1].status = 'success'
    })
    .catch(() => {
      progressList.value[1].percent = 100
      progressList.value[1].status = 'exception'
    })
  }

  // 3. 添加301重定向
  progressList.value[2].percent = 0
  progressList.value[2].status = 'normal'
  const redirectList = currentConfigImageConfig.value.redirectDomain || []
  let redirectPromise
  if (redirectList.length === 0) {
    progressList.value[2].percent = 100
    progressList.value[2].status = 'success'
    redirectPromise = Promise.resolve()
  } else {
    redirectPromise = Promise.all(
      redirectList.map(item =>
        setRedirectConfig({ source: item.split('|')[0], target: item.split('|')[1] })
      )
    ).then(() => {
      progressList.value[2].percent = 100
      progressList.value[2].status = 'success'
    }).catch(() => {
      progressList.value[2].percent = 100
      progressList.value[2].status = 'exception'
    })
  }

  // 4. 设置404页面
  progressList.value[3].percent = 0
  progressList.value[3].status = 'normal'
  let errorPagePromise
  if(currentConfigImageConfig.value.errorPage == '') {
    progressList.value[3].percent = 100
    progressList.value[3].status = 'success'
    errorPagePromise = Promise.resolve()
  } else {
    errorPagePromise = setErrorPage({ path: currentConfigImageConfig.value.errorPage })
      .then(() => {
        progressList.value[3].percent = 100
        progressList.value[3].status = 'success'
      })
      .catch(() => {
        progressList.value[3].percent = 100
        progressList.value[3].status = 'exception'
      })
  }

  // 5. 添加MIME 映射
  progressList.value[4].percent = 0
  progressList.value[4].status = 'normal'
  const mimeList = currentConfigImageConfig.value.mime || []
  let mimePromise
  if (mimeList.length === 0) {
    progressList.value[4].percent = 100
    progressList.value[4].status = 'success'
    mimePromise = Promise.resolve()
  } else {
    mimePromise = Promise.all(
      mimeList.map(mimeItem =>
        addMimeConfig({
          extension: mimeItem.split('|')[1],
          mineType: mimeItem.split('|')[0]
        })
      )
    ).then(() => {
      progressList.value[4].percent = 100
      progressList.value[4].status = 'success'
    }).catch(() => {
      progressList.value[4].percent = 100
      progressList.value[4].status = 'exception'
    })
  }

  // 6. PHP设置
  progressList.value[5].percent = 0
  progressList.value[5].status = 'normal'
  
  let phpLangPromise
  if(store.state.hostInfo?.specInfo?.language?.includes('NET')) {
    phpLangPromise = setPhpLang(currentConfigImageConfig.value.phpVersion, currentConfigImageConfig.value.phpSwitch.code)
  } else {
    phpLangPromise = Promise.resolve()
  }
  const phpChangePromise = setPhpChangeVersion(currentConfigImageConfig.value.phpVersion)
  const phpShortOpenTagPromise = updatePhpParam({
    phpIniKey: "short_open_tag",
    phpIniValue: currentConfigImageConfig.value.phpShortOpenTag.code
  })
  const phpDisplayErrorsPromise = updatePhpParam({
    phpIniKey: "display_errors",
    phpIniValue: currentConfigImageConfig.value.phpDisplayErrors.code
  })
  const phpErrorLogPromise = setPhpErrorLog(currentConfigImageConfig.value.phpErrLogSwitch.code)
  const phpObSwitchPromise = setPhpOb(currentConfigImageConfig.value.phpOBSwitch.code)
  const phpSetphpUploadSwitchPromise = setPhpUpload(currentConfigImageConfig.value.phpUploadSwitch.code)
  const phpMaxPhpUploadSizePromise = setPhpMaxUploadSize(currentConfigImageConfig.value.maxPhpUploadSize)
  const phpMaxInputTimePromise = updatePhpParam({
    phpIniKey: 'max_input_time',
    phpIniValue: currentConfigImageConfig.value.phpMaxInputTime,
  })
  const phpMaxFileUploadsPromise = updatePhpParam({
    phpIniKey: 'max_file_uploads',
    phpIniValue: currentConfigImageConfig.value.phpMaxFileUploads
  })
  const phpDataTimeZonePromise = updatePhpParam({
    phpIniKey: 'date.timezone',
    phpIniValue: currentConfigImageConfig.value.phpDateTimezone
  })
  const phpErrorReportingPromise = updatePhpParam({
    phpIniKey: 'error_reporting',
    phpIniValue: currentConfigImageConfig.value.phpErrorReporting.join(',')
  })
  const chown = currentConfigImageConfig.value.disabledFuncs?.includes('chown') ? 'OFF' : 'ON'
  const fsockopen = currentConfigImageConfig.value.disabledFuncs?.includes('fsockopen') ? 'OFF' : 'ON'
  const assert = currentConfigImageConfig.value.disabledFuncs?.includes('assert') ? 'OFF' : 'ON'
  let param = ''
  if (chown === 'OFF' && fsockopen === 'OFF' && assert === 'OFF') {
    param = 'chown,fsockopen,assert'
  } else if (chown === 'OFF' && fsockopen === 'OFF') {
    param = 'chown,fsockopen'
  } else if (fsockopen === 'OFF' && assert === 'OFF') {
    param = 'fsockopen,assert'
  } else if (chown === 'OFF' && assert === 'OFF') {
    param = 'chown,assert'
  } else if (chown === 'OFF') {
    param = 'chown'
  } else if (fsockopen === 'OFF') {
    param = 'fsockopen'
  } else if (assert === 'OFF') {
    param = 'assert'
  } else {
    param = 'none'
  }
  const phpsetPhpDisableFuncsPromise = setPhpDisableFuncs(param)
 
  const phpPromise = Promise.all([
    phpLangPromise,
    phpChangePromise,
    phpShortOpenTagPromise,
    phpDisplayErrorsPromise,
    phpErrorLogPromise,
    phpObSwitchPromise,
    phpSetphpUploadSwitchPromise,
    phpMaxPhpUploadSizePromise,
    phpMaxInputTimePromise,
    phpMaxFileUploadsPromise,
    phpDataTimeZonePromise,
    phpErrorReportingPromise,
    phpsetPhpDisableFuncsPromise,
  ]).then(() => {
    progressList.value[5].percent = 100
    progressList.value[5].status = 'success'
  }).catch(() => {
    progressList.value[5].percent = 100
    progressList.value[5].status = 'exception'
  })

  let scriptErrorPromise
  if(progressList.value[6]?.title == '设置脚本错误信息') {
    // 7. 设置脚本错误信息有net信息添加/specInfo?.language?.includes('NET')
    progressList.value[6].percent = 0
    progressList.value[6].status = 'normal'
    scriptErrorPromise = setDotnetScriptError({
      notify: currentConfigImageConfig.value.scriptError[0],
      msg: currentConfigImageConfig.value.scriptError[1]
    }).then(() => {
      progressList.value[6].percent = 100
      progressList.value[6].status = 'success'
    }).catch(() => {
      progressList.value[6].percent = 100
      progressList.value[6].status = 'exception'
    })
  } else {
    scriptErrorPromise = Promise.resolve()
  }

  // 判断是否有net/specInfo?.language?.includes('NET')
  let dotnetPromise = Promise.resolve()
  if(progressList.value[7]?.title == '.NET设置') {
    // 8. .NET设置
    progressList.value[7].percent = 0
    progressList.value[7].status = 'normal'
    const phpSetDotnetTrustedLevelPromise = setDotnetTrustedLevel(currentConfigImageConfig.value.dotNetTrustedLevel)
    const phpSetDotnetChangeVersionPromise = setDotnetChangeVersion(currentConfigImageConfig.value.dotnetVersion, currentConfigImageConfig.value.dotnetMode)
    dotnetPromise = Promise.all([
      phpSetDotnetTrustedLevelPromise,
      phpSetDotnetChangeVersionPromise,
    ]).then(() => {
      progressList.value[7].percent = 100
      progressList.value[7].status = 'success'
    }).catch(() => {
      progressList.value[7].percent = 100
      progressList.value[7].status = 'exception'
    })
  }

  // 汇总所有Promise
  const allPromise = Promise.all([
    homePromise,
    rewritePromise,
    redirectPromise,
    errorPagePromise,
    scriptErrorPromise,
    mimePromise,
    phpPromise,
    dotnetPromise
  ])

  // 判断全部成功或有失败
  allPromise.then(() => {
    settingShow.value = false
    updateTaskStatus(currentConfigTaskId.value, { postStatus: 'CONFIGURATION_SUCCESS' })
  }).catch(() => {
    settingShow.value = false
    updateTaskStatus(currentConfigTaskId.value, { postStatus: 'CONFIGURATION_STOP' })
  })
}

const progressList = ref([
        { icon: 'cloud-upload', title: '设置网站首页', percent: 100, status: 'normal' },
        { icon: 'database', title: '设置伪静态', percent: 100, status: 'normal' },
        { icon: 'server', title: '添加301重定向', percent: 100, status: 'normal' },
        { icon: 'wordpress', title: '设置404页面', percent: 100, status: 'normal' },
        // { icon: 'wordpress', title: '设置脚本错误信息', percent: 100, status: 'normal' },
        { icon: 'wordpress', title: '添加MIME 映射', percent: 100, status: 'normal' },
        { icon: 'wordpress', title: 'PHP设置', percent: 100, status: 'normal' },
        // { icon: 'wordpress', title: '.NET设置', percent: 100, status: 'normal' }
      ])

// 添加临时任务到任务队列
const addTempTask = (taskList) => {
  if (taskList?.length) {
    // 文件转换为临时任务
    const tempTasks = taskList.map((task) => {
      const {
        id, loading, progress, createTime, endTime, filename, whichFile,
        size, totalSize, cancel, fileList, taskType, ratio, notifyStatus,
        downloaded, rate, taskStatus, taskInfo
      } = task
      const res: any = {
        id,
        createTime,
        endTime,
        size,
        totalSize,
        taskStatus: 'RUNNING',
        taskType,
        filename,
        // 任务进度
        progress,
        notifyStatus,
        total: fileList.length,
      }

      if (taskType === 'COMPRESS') {
        rate && (res.rate = rate)
        downloaded && (res.downloaded = downloaded)
      }
      if (taskType === 'DECOMPRESS') {
        res.total = task.total
        res.processed = task.processed
        if (taskStatus) {
          res.taskInfo = taskInfo
          res.taskStatus = taskStatus
        }
      }
      if (taskType === 'UPLOAD_FILE') {
        res.failed = fileList.filter((o) => o.failed).length
        res.succeed = fileList.filter((o) => (o.done && !o.failed)).length
        res.uploaded = fileList.filter((o) => o.done).length
        res.uploading = fileList.filter((o) => !o.done).length
        // 上传文件百分比
        res.ratio = ratio
        res.whichFile = whichFile
        if (fileList.find((o) => o.failed)) {
          res.taskStatus = 'RUNNING_FAIL'
        }
      }
      if (cancel) {
        res.taskStatus = 'STOP'
      }
      if (loading === false) {
        res.endTime = Xinnet.util.formatTime(new Date())
        if (!fileList.find((o) => o.failed)) {
          res.taskStatus = 'RUNNING_SUCCESS'
        }
      }

      // 已完成的未读临时任务，立即通知
      if (notifyStatus === 0 && ['RUNNING_SUCCESS', 'RUNNING_FAIL'].includes(res.taskStatus)) {
        notify(res)
        store.commit('tempTask/updateTaskState', { task: res, value: 1 })
      }
      return res
    })
    tasks.value = [...tempTasks, ..._tasks.value].slice(0, 5)
    let num = 0
    tasks.value?.forEach((t) => {
      if(t.taskStatus == 'RUNNING' || t.taskStatus == 'WAIT') {
        num += 1
      }
      if(runningTask.value == t.id && t.taskType != 'DB_BACKUP' && (t.taskStatus == 'RUNNING' || t.taskStatus == 'WAIT')) {
        runningNotify(t)
      }
    })
    count.value = num
  }
}

const notifyTasks = () => {
  const { hostService } = store.state.hostInfo
  if (hostService?.hostCode) {
    getTasks(hostService.hostCode, false)
    // store.commit('tempTask/triggerTask', true)
  }
}




watch(() => store.state.tempTask.taskList, (taskList) => {
  if (taskList?.[0]?.fileList?.length) {
    addTempTask(taskList)
  }
  // 有未完成临时任务
  if (taskList?.[0]?.fileList?.find((o) => !o.done)) {
    Xinnet.taskRunning = true
  } else {
    Xinnet.taskRunning = false
  }
}, { deep: true, immediate: true })

watch(() => store.state.hostInfo, (host) => {
  if (host?.hostService?.hostCode) {
    queryTaskPageHandel(host.hostService.hostCode)
    getTasks(host.hostService.hostCode, true)
  }
}, { deep: true, immediate: true })



provide('getTasks', notifyTasks)
</script>

<style lang="scss" scoped>
// @import "@/styles/mixins.scss";

.ant-layout-sider {
  position: relative;
  z-index: 12;
  .ant-menu {
    width: 208px;
    overflow-y: auto;
    height: calc(100vh - 120px) !important;
  }
}
.ant-layout-header {
  display: flex;
  align-items: center;
  padding-inline: 0;
  padding: 0!important;
  z-index: 12;
  width: 100%;
  height: 56px!important;
  line-height: 56px!important;
  background: #fff !important;
  overflow: hidden;
  border-bottom: 1px solid rgba(0,0,0,0.06);
}
.ant-layout-content,
.ant-layout {
  background-color: transparent;
}
.main-container {
  margin: 0px;
  width: calc(100vw - 208px);
  height: 100vh;
  overflow: auto;
}
.main-content {
  min-width: 1228px;
  margin-top: 56px;
  padding-left: 20px;
}
.main-header {
  width: 100%;
  height: 100%;
}
.main-logo {
  width: 250px;
  height: 100%;
  margin-left: 16px;
  user-select: none;
  .logo {
    margin-top: -5px;
  }
  .title {
    font-weight: 600;
    font-size: 16px;
    color: rgba(0,0,0,0.85);
    line-height: 24px;
    text-align: left;
  }
   .hostInfo{
    margin-left: 18px;
    line-height: normal;
    .tip {
      font-size: 10px;
      color: #666666;
      width: 72px;
      height: 18px;
      background: #E9E9E9;
      border-radius: 4px;
      text-align: center;
      line-height: 18px;
      margin-top: 10px;
    }
    .host{
      font-size: 14px;
      color: #333333;
      font-weight: 500;
      line-height: 14px;
      margin-top: 4px;
    }
  }
}
.main-navbar {
  flex: 1 1 auto;
  height: 100%;
  user-select: none;
  text-align: right;
  .drop-button {
    display: inline-block;
    height: 30px;
    line-height: 30px;
  }
  .icon {
    width: 28px;
    height: 28px;
    vertical-align: middle;
  }
  > a {
    margin-right: 40px;
  }
}
.main-menu {
  width: 208px;
  background-color: #fff;
  border-right: 1px solid rgba(0,0,0,0.06);
  .menu {
    // width: 192px;
    width: 100%;
    height: 40px;
    line-height: 40px;
    // border-radius: 4px;
    padding-left: 24px;
    color: #000000A6;
    margin: auto;
    &:hover {
      // color: #8B8B8C;
      color: rgba(0,0,0,0.85);
      background: #EBEBEB;
      // background: rgba(0, 0, 0, 0.03);
    }
    &.active {
      // color: #000000;
      // background: rgba(0, 0, 0, 0.03);
      color: rgba(0,0,0,0.85);
      background: rgba(0,0,0,0.04);
      box-shadow: inset 4px 0px 0px 0px #EF2937;
    }
  }
  .bhr {
    height: 4px;
    margin: 0 8px;
    border-bottom: 1px solid rgba(0,0,0,0.06);
  }
}
.link {
  font-weight: 400;
  font-size: 14px;
  color: rgba(0,0,0,0.85);
  line-height: 20px;
  &:hover {
    color: #404040;
  }
}
/* 全局样式文件，比如 styles.css 或者 App.vue 中的 <style> 标签内 */
.ant-notification-notice-message {
  font-size: 14px; /* 修改为你想要的字号 */
}
</style>

<style lang="scss">
.cp-left-menu.ant-menu {
  // max-height: calc(100vh - 132px);
  padding-top: 0px;
  .ant-menu-item {
    color: rgba(0, 0, 0, 0.65);
    height: 40px;
    // width: calc(100% - 16px);
    width: 100%;
    // margin-left: auto;
    // margin-right: auto;
    margin: 0;
    background: transparent;
    &.ant-menu-item-selected {
      // color: #000000;
      // background: rgba(0,0,0,0.03);
      outline: none;
      background: rgba(0, 0, 0, 0.04);
      box-shadow: inset 4px 0px 0px 0px #EF2937;
      color: rgba(0, 0, 0, 0.85);
      border-radius: 0;
      &:hover {
        color: rgba(0, 0, 0, 0.85) !important;
      }
    }
    &:hover {
      // border-radius: 4px;
      color: rgba(0, 0, 0, 0.85)  !important;
      background: rgba(0,0,0,0.03) !important;
    }
  }
  .ant-menu-sub {
    // background-color: #fff !important;
    background: transparent !important;
  }
  .ant-menu-submenu {
    .ant-menu-submenu-title {
      color: rgba(0, 0, 0, 0.65);
      // width: calc(100% - 16px);
      // margin-left: auto;
      // margin-right: auto;
      margin: 0;
      width: 100%;
      &:hover {
        // border-radius: 4px;
        color: rgba(0, 0, 0, 0.85) !important;
      }
    }
    &.ant-menu-submenu-selected {
      .ant-menu-submenu-title {
        color: rgba(0, 0, 0, 0.65);
        outline: none;
        &:hover {
          color: #000000 !important;
        }
      }
    }
  }
}
.header-list{
  .text{
    font-size: 14px;
    color: #666;
    font-weight: 500;
  }
  .tip{
    font-size: 12px;
    color: #999;
  }
  .text1 {
    line-height: normal;
    margin-top: 6px;
    margin-left: 22px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    width: 417px;
    font-size: 14px;
    color: #666;
    line-height: 16px;
    
    .textDomains {
      >span {
        color: #E9E9E9; 
        margin: 0 6px;
      }
    }
  }
  .tip1{
    font-size: 12px;
    color: #999;
    margin-left: 22px;
    margin-top: 6px;
    line-height: 14px;
  }
  .imgs {
    display: inline-block;
    width: 14px;
    height: 14px;
    background: url("@/assets/images/header_list_icon.png");
  }
  .dropdownItem {
    line-height: 16px;
    display: flex;
    align-items: center;
  }
  .dropdownItemsActive {
    .dropdownItem span {
      color: #1677FF!important;
    }
    .imgs {
      background: url("@/assets/images/header_list_icon1.png");
    }
  }
}

.progress-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
  margin-top: 15px;
  // padding: 20px;
}

.progress-item {
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 1;
  width: 100%;
}

.progress-icon {
  font-size: 24px;
}

.progress-text {
  // display: flex;
  flex-direction: column;
  gap: 2px;
  // margin-left: 20px;
  flex: 1;
  padding: 0 10px;
  width: 100%;
}

.progress-title {
  font-size: 16px;
  font-weight: bold;
  display: inline-block;
  width: 96%;
}

.progress-bar {
  width: 500px !important;
}

.progress-status {
  color: green;
}

.next-button {
  margin-top: 20px;
  padding: 10px 20px;
  font-size: 16px;
}

.install-mask {
  position: fixed;
  z-index: 9999;
  left: 0; top: 0; right: 0; bottom: 0;
  background: rgba(255,255,255,0.85);
  display: flex;
  align-items: center;
  justify-content: center;
}
.install-mask-content {
  text-align: center;
}
.install-mask-text {
  margin-top: 24px;
  font-size: 18px;
  color: #333;
}
</style>
